/**
 * Created by PanJiaChen on 16/11/18.
 */
import router from "../router";
import { Dialog } from 'vant';
import { ZqcUrlMatterCon, ZqcUrlCompanyone } from '../config'
import { setQuestion } from '../utils/storage'
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}


export function clickUrl(url, query) {
  var u = navigator.userAgent
  if (u.indexOf('miniProgram') !== -1) {
    // 在微信小程序
    var urlStr = '../webview/webview?url=' + url
    if (query != null) {
      for (var key in query) {
        urlStr = urlStr + "&" + key + "=" + query[key]
      }
    }
    window.wx.miniProgram.navigateTo({ url: urlStr })
  } else {
    // 在微信网页
    router.push({ path: url, query: query })
  }
}

// export function clickUrlToPhone(url, query) {
//   var u = navigator.userAgent
//   if (u.indexOf('miniProgram') !== -1) {
//     // 在微信小程序
//     var urlStr = '/pages/phone/phone?url=' + url
//     if (query != null) {
//       for (var key in query) {
//         urlStr = urlStr + "&" + key + "=" + query[key]
//       }
//     }
//     window.wx.miniProgram.navigateTo({ url: urlStr })
//   } else {
//     // 在微信网页
//     window.location.href = `tel:${query.phone}`
//   }
// }

export function clickUrlToPhone(url, query) {
  console.log(url,query,149)
  var u = navigator.userAgent
  if (u.indexOf('miniProgram') !== -1) {
    var urlStr = '/pages/phone/phone?url=' + url
    if (query != null) {
      for (var key in query) {
        urlStr = urlStr + "&" + key + "=" + query[key]
      }
    }
    window.wx.miniProgram.navigateTo({ url: urlStr })
  } else if (query.type == 'getPhone') {
    router.push({ path: '/purchase', query: query })
  } else {
    // 在微信网页
    window.location.href = `tel:${query.phone}`
  }
}

export function debounce(func, wait = 1000) { //可以放入项目中的公共方法中进行调用
  let timeout;
  return function (event) {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.call(this, event)
    }, wait)
  }
}

export function desensitization(str, frontLen, endLen){
  if (!str) return ''
  var len = str.length - frontLen - endLen;
  var xing = '';
  for (var i = 0; i < len; i++) {
    xing += '*';
  }
  return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
}

/**
     * 判断是否有填报内容，没有=》跳转到政企超公众号的填报调研内容
     */
export function checkResearch(questions) {
  if (sessionStorage.getItem('zqcljQuestionsFlag')) {
    return false
  }
  for (var i = 0; i < questions.length; i++) {
    var q = questions[i]
    if (q.status < 2 || q.status == 4) {
      sessionStorage.setItem('zqcljQuestionsFlag',1)
      Dialog.confirm({
        title: '温馨提示',
        message: '你有未填报的调研内容，是否前往填报'
      }).then(() => {
        setQuestion(q)
        sessionStorage.setItem('urlZct', location.href)
        window.location.href = window.location.origin + ZqcUrlMatterCon
      }).catch(() => {
      })
      return
    }
  }
  
}

export function goCodeFirm(userInfo) {
  var flag = false
  if (!userInfo.avatar && !userInfo.nickname) {
    flag = true
    Dialog.confirm({
      title: "微信授权",
      message: "获取您的用户信息",
    }).then(() => {
      sessionStorage.setItem('url', location.href)
      let url = 'http://' + window.location.host + '/codeFirm.html'
      location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx64422800da4015b7&redirect_uri=' + url + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
    }).catch(() => {

    })
  }
  return flag
}

 